/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCoursesByName200,
  GetApiV1ExamCoursesByName400,
  GetApiV1ExamCoursesByName401,
  GetApiV1ExamCoursesByName500,
  GetApiV1ExamCoursesByNameQueryParams,
  GetApiV1ExamCoursesByNameQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamCoursesByName.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamCoursesByNameQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  id: z.optional(z.coerce.number().int()),
  companyId: z.optional(z.coerce.number().int()),
  includeRelationship: z.boolean().default(false),
}) as unknown as ToZod<GetApiV1ExamCoursesByNameQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCoursesByName200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamCoursesByName200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCoursesByName400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCoursesByName400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCoursesByName401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCoursesByName401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCoursesByName500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCoursesByName500>;

export const getApiV1ExamCoursesByNameQueryResponseSchema = z.lazy(
  () => getApiV1ExamCoursesByName200Schema,
) as unknown as ToZod<GetApiV1ExamCoursesByNameQueryResponse>;
